import dayjs from "dayjs";
import { detectLeaveType, detectDates, detectDayCount } from "./leaveNLP";

export const detectAILeaveAction = (query: string) => {
    if (!query) return null;

    const q = query.toLowerCase().trim();

    // CANCEL leave
    if (q.includes("cancel") && q.includes("all") && (q.includes("leave") || q.includes("leaves"))) {
        return { action: "cancel_all_leave" };
    }

    // CANCEL one leave
    if (q.includes("cancel") && q.includes("leave")) {
        return { action: "cancel_leave" };
    }

    // APPLY leave begins here
    if (q.includes("apply") && q.includes("leave")) {
        const type = detectLeaveType(q);

        // today / tomorrow / next week
        if (q.includes("today")) {
            const d = dayjs().format("YYYY-MM-DD");
            return { action: "apply_leave", type, fromDate: d, toDate: d };
        }
        if (q.includes("tomorrow")) {
            const d = dayjs().add(1, "day").format("YYYY-MM-DD");
            return { action: "apply_leave", type, fromDate: d, toDate: d };
        }
        if (q.includes("next week")) {
            const d = dayjs().add(7, "day").format("YYYY-MM-DD");
            return { action: "apply_leave", type, fromDate: d, toDate: d };
        }
        const detected = detectDates(q);
        if (detected) {
            return { action: "apply_leave", type, fromDate: detected.from, toDate: detected.to };
        }
        // Duration
        const days = detectDayCount(q);
        if (days) {
            return { action: "apply_leave", type, days };
        }

        return { action: "apply_leave", type, ask: true };
    }

    return null;
};
